<script setup>
const emit = defineEmits('close')

function close () {
  emit('close')
}
</script>

<template>
  <teleport to="body" class="fixed left-0 top-0 w-full h-screen">
    <div
      class="fixed left-0 top-0 w-full h-screen bg-gray bg-opacity-40 opacity-100 flex justify-center"
      style="background: rgba(0, 0, 0, 0.3); z-index: 110"
    >
      <div class="w-full relative m-auto overflow-x-hidden overflow-y-auto">
        <div v-click-outside="close" class="bg-white min-h-50 mx-auto">
          <slot />
        </div>
      </div>
    </div>
  </teleport>
</template>
